module.exports = __webpack_public_path__ + "25d5eea6458b22e727a5d4badf7f50c8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/happy-1.png
// module id = 2136
// module chunks = 0